import { render, staticRenderFns } from "./EmailTemplateEdit.vue?vue&type=template&id=5c2d8359&"
import script from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports